import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { es_ES, NZ_I18N } from 'ng-zorro-antd/i18n';
import { DialogsModule } from '@core/modules/dialogs/dialogs.module';
import { QuillModule } from 'ngx-quill';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MOMENT_DATE_FORMATS } from '@core/date-utils/moment-date-formats';
import { GlobalErrorHandler } from '@core/handlers/global-error.handler';
import { AntDesignIconsModule } from '@core/modules/ant-design-icons/ant-design-icons.module';

const globalRippleConfig: RippleGlobalOptions = {
	disabled: true,
	animation: {
		enterDuration: 0,
		exitDuration: 0,
	},
};

const quillToolbarOptions = [
	['bold', 'italic', 'underline', 'strike'],
	[{ color: [] }, { background: [] }],
	[{ header: [1, 2, 3, 4, 5, 6, false] }],
	[{ list: 'ordered' }, { list: 'bullet' }],
	[{ script: 'sub' }, { script: 'super' }],
	['link', 'image'],
	// https://quilljs.com/docs/modules/toolbar/
];

@NgModule({
	imports: [
		CommonModule,
		MatSnackBarModule,
		DialogsModule,
		QuillModule.forRoot({
			modules: {
				toolbar: quillToolbarOptions,
			},
		}),
		AntDesignIconsModule,
	],
	providers: [
		{ provide: NZ_I18N, useValue: es_ES },
		{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
		{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', floatLabel: 'auto' } },
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
		{ provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: { autoActiveFirstOption: true } },
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
		},
		{ provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
	],
})
export class CoreModule {
	// Core Module can only be imported once in the application
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule is already loaded. Import it in the AppModule only');
		}
	}
}
